import React, { useState } from 'react'
import RichTextEditor from 'react-rte'
import styled from 'styled-components'
import Flex from 'components/Flex'
import Label from 'components/Form/Label'
import { FONT } from 'theme/font'

const toolbarConfig = {
  display: [
    'INLINE_STYLE_BUTTONS',
    'BLOCK_TYPE_BUTTONS',
    'BLOCK_TYPE_DROPDOWN',
  ],
  INLINE_STYLE_BUTTONS: [
    { label: 'Bold', style: 'BOLD', className: 'header-button' },
    { label: 'Italic', style: 'ITALIC', className: 'header-button' },
    { label: 'Underline', style: 'UNDERLINE', className: 'header-button' },
  ],
  BLOCK_TYPE_DROPDOWN: [
    { label: 'Normal text', style: 'unstyled' },
    { label: 'Heading 1', style: 'header-one' },
    { label: 'Heading 2', style: 'header-two' },
    { label: 'Heading 3', style: 'header-three' },
  ],
  BLOCK_TYPE_BUTTONS: [
    {
      label: 'UL',
      style: 'unordered-list-item',
      className: 'header-button',
    },
    { label: 'OL', style: 'ordered-list-item', className: 'header-button' },
  ],
}
const StyledEditor = styled(RichTextEditor)`
  margin-top: 10px;
  font-family: ${FONT.FONT_FAMILY};
  > div {
    background: #fafafb;
  }
  .header-button {
    border: none;
  }
  .public-DraftEditor-content {
    min-height: 100px;
    padding: 0px 3px;
    border-radius: 10px;
  }
  .IconButton__icon___3YgOS {
    background-size: 22px;
    border-radius: 15px;  
  }
  .DraftEditor-editorContainer {
    padding: 10px 0;
  }
  .EditorToolbar__root___3_Aqz {
    margin: 0;
    padding: 10px 5px;
  }
  .DraftEditor-root {
    background: #fafafb;
  }
`

const RichEditor = ({
  onChange,
  value = '',
  labelName = 'Job description *',
  placeholder = 'Enter Description here...',
}) => {
  const [state, setState] = useState({
    description: value
      ? RichTextEditor.createValueFromString(value, 'html')
      : RichTextEditor.createEmptyValue(),
  })
  const handleOnchange = (val, key) => {
    setState({ [key]: val })
    if (onChange) {
      onChange(val.toString('html'))
    }
  }
  return (
    <div>
      <Flex centerVertically>
        <Label>{labelName}</Label>
      </Flex>
      <StyledEditor
        value={state.description}
        toolbarConfig={toolbarConfig}
        onChange={val => handleOnchange(val, 'description')}
        placeholder={placeholder}
      />
    </div>
  )
}

export default RichEditor
